<template>
  <div>
    <childLogo></childLogo>
    <div class="navbar-dark">
        <div class="sigma-content">
          <div class="sigma-middle-line">
            <span class="sigma-line-text">成绩看板</span>
          </div>
        </div>
        <div style="font-size: 21px;margin: 15px;color: #5e5e5e;text-align: center">{{ siteName }}</div>
      </div>
    <div class="sel">
      <div class="first">
        <el-button size="small"></el-button>
        未完成
      </div>
      <div class="second">
        <el-button size="small"></el-button>
        已完成
      </div>
      <div class="third">
        <el-button size="small"></el-button>
        未开始
      </div>
    </div>
    <el-row class="news-center">
      <el-col v-for="item in expertList" :key="item.id" :xs="12" :sm="12" :md="4" :lg="4" :xl="4">
        <el-button  class="wks" v-if="item.status === '0'"  @click="queryWork(item.id)">{{item.name}}</el-button>
        <el-button  class="ywc" v-if="item.status === '1'"  @click="queryWork(item.id)">{{item.name}}</el-button>
        <el-button  class="wwc" v-if="item.status === '2'"  @click="queryWork(item.id)">{{item.name}}</el-button>
      </el-col>
    </el-row>
    <el-row class="container" style="margin-top: 2%">
      <el-form>
        <el-col :xs="8" :sm="12" :md="12" :lg="8" :xl="12">
          <el-form-item label="作品类型" prop="labelName" style="margin-top: 2%;">
            <el-select
              @change="initGetList"
              filterable
              v-model="queryParams.formType"
              placeholder="请选择作品类型"
              class="Statistics">
              <el-option
                v-for="item in workTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="8" :sm="12" :md="12" :lg="8" :xl="12">
          <el-form-item label="流程类型" style="margin-top: 2%;" class="stItems">
            <el-select
              @change="initGetList"
              filterable
              v-model="queryParams.flowId"
              placeholder="请选择流程类型"
              class="Statistics">
              <el-option
                v-for="item in flowList"
                :key="item.node.flowId"
                :label="item.node.label"
                :value="item.node.flowId"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>

    <el-row class="news-center">
      <!-- 列表 -->
      <el-table
        ref="multipleTable"
        :data="tableData"
        style="width: 100%"
        row-key="id"
      >
        <el-table-column type="index" label="排名" width="120" align="center">
          <template slot-scope="scope">
            <span>{{(queryParams.pageNum - 1) * queryParams.pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="worksName" label="作品名称" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="finalGrade" label="最终成绩" align="center"></el-table-column>
      </el-table>
      <!-- 分页 -->
      <template>
        <pagination
          style="text-align: center"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="getTableList"
          layout=" prev, pager, next, jumper"
        />
      </template>
      <workAssign
        :workDiolog.sync="workDiolog"
        @getTableList="getTableList"
        :formType="queryParams.formType"
        :flowId="queryParams.flowId"
        ref="workAssign"
      ></workAssign>
    </el-row>
  </div>
</template>

<script>
import ChildLogo from "@/components/ChildLogo.vue";
import Pagination from "@/components/Pagination";
import workAssign from "@/views/ExpertRatingDialog";
import {getPowerNode } from '@/api/system/flowNode'
import {listWorksCategoryConf} from "@/api/work/worksCategoryConf"
import {siteMess} from "@/api/system/index"
export default {
  name: "expertRating",
  components: {
    ChildLogo,
    Pagination,
    workAssign
  },
  data() {
    return {
      siteName:"",
      workTypeList:[],
      workIdExperts:[],
      siteId: this.siteId,
      channelId: undefined,
      //站点下拉选项
      siteOption: [],
      //修改结果集合
      editList: [],
      //选中作品数据
      selectedWorks: [],
      //专家列表
      expertList: [],
      //选择的专家
      selectedExpert: undefined,
      //专家ID
      expertId: undefined,
      //作品选择弹出层
      workDiolog: false,
      notice: {},
      //当前大赛当前专家需要评审的表格数据
      tableData: [],
      //表格数据总数
      total: 0,
      //表单
      form: {},
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        siteId: this.siteId,
        exportId: undefined,
        worksName: undefined,
        flowId:undefined,
      },
      flowList:[],
    };
  },
  async created() {
    siteMess(this.siteURL,this.siteId).then(res=>{
      this.siteName = res.data.name;
    })
    await listWorksCategoryConf(this.baseURL,{
      siteId: this.siteId
    }).then(res => {
      this.workTypeList = res.rows
      if (this.workTypeList.length == 0) {
        this.loading = false
        this.$message.info('当前站点尚未配置作品类型或您没用权限操作,请联系管理员')
        return
      }
      this.queryParams.formType = this.workTypeList[0].id
    })
    await getPowerNode(this.systemURL,this.siteId).then(nodeRes => {
      this.flowList = nodeRes.data
    }).catch(error=>{
      this.loading = false
    })
    if (!this.flowList) {
      this.loading = false
      this.$message.info("当前站点没有配置流程信息，无法进行审核操作")
      return
    }
    if (this.flowList.length == 0) {
      this.loading = false
      this.$message.info("当前站点没有配置流程信息，无法进行审核操作")
      return
    }
    if (!this.queryParams.flowId) {
      this.queryParams.flowId = this.flowList[0].node.flowId
      this.getTableList()
    }

    var url = this.siteURL + "/actuator/expert/getInfoByExpert";
    this.axios
      .get(url, { params: { userId: this.$store.state.user.userId } })
      .then((response) => {
        if (response.data.code === 200) {
          this.expertId = response.data.data.id;
          //专家列表
          this.getExpertList();
          //获取列表
          this.getTableList();
        }
      });
    this.getNoticeContent();
  },
  mounted() {

  },
  methods: {
    getWorkType() {
      let obj = this.workTypeList.filter((w) => {
        return w.id == this.queryParams.formType
      })
      return obj[0]
    },
    initGetList(){
      this.$forceUpdate();
      this.queryParams.pageNum=1
      this.getTableList()
    },
    async getList() {
      if (!this.queryParams.flowId) {
        this.$message.error("当前站点没有流程信息")
        this.loading = false
        return
      }
    },
    /** 专家列表 */
    getExpertList() {
      var url =
        this.siteURL +
        "/actuator/expertGroup/ExpertList?siteId=" +
        this.siteId+"&id="+this.expertId;
      this.axios.get(url).then((response) => {
        if (response.data.code === 200) {
          this.expertList = response.data.rows;
        }
      });
    },
    /** 获取作品评分列表 */
    getTableList() {
      var url = this.baseURL + '/actuator/works/listExpertGroup'
      this.queryParams.id = this.expertId
      this.queryParams.content = this.queryParams.formType
      this.axios.get(url, {params: this.queryParams}).then((response) => {
        if (response.data.code === 200) {
          let worksList = []
          let workIds = []
          response.data.rows.forEach(function (item, index) {
            let obj = {}
            let workNames = JSON.parse(response.data.rows[index].worksName)
            obj.worksName = workNames.workName
            obj.expertId = response.data.rows[index].expertId
            obj.workId = response.data.rows[index].id
            obj.finalGrade = response.data.rows[index].finalGrade
            worksList.push(obj)
            workIds.push(response.data.rows[index].id)
          })
          this.tableData = worksList
          this.workIdExperts = workIds
          this.total = response.data.total
          this.$forceUpdate()
        }
      })
    },
    /**  */
    /** 动态获取名称 */
    getNoticeContent() {
      var url = encodeURI(
        this.siteURL +
          "/actuator/channel/list?siteId=" +
          this.siteId +
          "&url=" +
          this.$route.path
      );
      this.axios.get(url, {}).then((response) => {
        this.notice = response.data.rows[0];
        this.channelId = response.data.rows[0].id;
      });
    },
    queryWork(id) {
      this.workDiolog = true
      this.$refs.workAssign.getList(id)
    },
    /** 选择作品改变 */
    handleSelectionChange(selection) {
      this.selectedWorks = selection.map((item) => item.id);
    },
    /** 条件查询*/
    handleQuery() {
      this.getTableList();
    },
    /**重置 */
    resetQuery() {
      this.queryParams.worksName = undefined;
      this.getTableList();
    },
    /** 查看作品详情 */
    handleQueryWorkDetail(data) {
      let routeUrl = this.$router.resolve({
        path: "/workDetailAll",
        query: { id: data.workId, expertId: data.exportId },
      });
      window.open(routeUrl.href);
    },
    /** 表单重置 */
    reset() {
      this.form = {
        id: undefined,
        workId: undefined,
        exportId: undefined,
        grade: undefined,
        status: "0",
        remark: undefined,
        sort: undefined,
        createTime: undefined,
        createBy: undefined,
        updateTime: undefined,
        updateBy: undefined,
        delFlag: undefined,
        contWorkExportList: [],
        contWorkRecordList: [],
        ids: [],
      };
    },
  },
};
</script>

<style scoped>
/* 通知公告基础模块 */
.sel {
  height: 80px;
  width: 30%;
  margin: 0 1% 1% 1%;
  background-color: #FFFFFF;
}

.first {
  display: flex;
  justify-content: space-between;
  position: absolute;
  margin-top: 2%;
  margin-left: 60%;
}

.first button {
  background-color: #B1B1B1;
  border: none;
  border-right: 5px white solid;
}


.second {
  display: flex;
  justify-content: space-between;
  position: absolute;
  margin-top: 2%;
  margin-left: 70%;
}

.second button {
  background-color: #36CBCB;
  border: none;
  border-right: 5px white solid;
}

.third {
  display: flex;
  justify-content: space-between;
  position: absolute;
  margin-top: 2%;
  margin-left: 80%;
}

.third button {
  background-color: #F2637B;
  border: none;
  border-right: 5px white solid;
}

.wks {
  border-radius: 5px;
  color: #FFFFFF;
  background-color: #F2637B;;
}

.ywc {
  border-radius: 5px;
  color: #FFFFFF;
  background-color: #36CBCB;
}

.wwc {
  border-radius: 5px;
  color: #FFFFFF;
  background-color: #B1B1B1;
}

.trends {
  min-height: 80px;
}
.sigma-content {
  margin: 40px 0 10px;
  text-align: center;
  background-color: #fff;
}
.sigma-middle-line:before {
  content: "";
  display: block;
  height: 1px;
  width: 80%;
  background-color: #0c70fc; /*颜色需与bai主题大背景du色一致zhi*/
  position: relative;
  top: 25px; /*调节线高*/
  left: 10%;
}
.sigma-line-text {
  display: inline-block;
  background: #fff;
  padding: 0 18px 0 18px;
  position: relative;
  font-size: 28px;
  font-weight: 500;
  color: #0c70fc;
}
.trends-text {
  margin-left: 10px;
  float: left;
  height: 40px;
  margin-top: 10px;
  line-height: 40px;
}
.trends-text-cn {
  font-size: 24px;
}
.trends-text-en {
  font-size: 15px;
  color: #666666;
}

.title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* 边框样式 */
.box-boder {
  border-bottom: 1px solid #666666;
}

/* 通知公告内容基础样式 */
.trends-notice {
  padding-bottom: 30px;
  background-color: #f5f5f5;
  color: #666666;
}

.Statistics{
  width: 60%;
}

@media screen and (max-width:800px){
  .Statistics{
    width: 100%;
  }

  .stItems{
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ExpertRating.vue